import I18n from "i18n-js";
import React from "react";

export default class BuilderHeader extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, onSave = () => {} } = this.props;
    return (
      <div className="BuilderHeader">
        <div
          className="CloseEditor"
          onClick={() => {
            const { backUrl } = this.props;
            if (backUrl) {
              window.location.href = backUrl;
            } else {
              history.back();
            }
          }}
        >
          <span className="fa fa-arrow-left"></span>
          {I18n.t("admin.back")}
        </div>
        <div className="HeaderTitle">{title}</div>
        <div className="HeaderToolbar">
          <button type="button" onClick={onSave}>
            {I18n.t("admin.save")}
          </button>
        </div>
      </div>
    );
  }
}
